export enum StatusSupplierInventoryWarehouseEnum {
  Available = 1,
  Unavailable = 2,
  PendingToMap = 3
}
